export default __webpack_public_path__ + "static/media/left gloves.2a4f4973.png";